<template>
  <div class="center-container">
    <div class="center-content">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export default class LayoutCenter extends Vue {}
</script>

<style scoped>
.center-container {
  height: 100vh;
  position: relative;
}

.center-content {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
